import { useQuery } from "@tanstack/react-query";

async function fetchJson<T>(url: string): Promise<T> {
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) throw new Error(`${res.status}`);
  return res.json();
}

export function useUsageBalance() {
  return useQuery({
    queryKey: ["/api/usage/balance"],
    queryFn: () =>
      fetchJson<{ balance: number; plan: any; usedThisCycle: number; hasStripeSubscription?: boolean }>("/api/usage/balance"),
    staleTime: 60_000,
  });
}

export function useUsageActions(limit = 20) {
  return useQuery({
    queryKey: ["/api/usage/actions", limit],
    queryFn: () => fetchJson<{ rows: any[] }>(`/api/usage/actions?limit=${limit}`),
  });
}

export function useBrandBreakdown() {
  return useQuery({
    queryKey: ["/api/usage/brand-breakdown"],
    queryFn: () => fetchJson<{ rows: any[] }>("/api/usage/brand-breakdown"),
  });
}

export function usePublicPlans() {
  return useQuery({
    queryKey: ["/api/usage/plans"],
    queryFn: () => fetchJson<{ rows: any[] }>("/api/usage/plans"),
  });
}
